/**
 * @overview Helpers for the DOM.
 *
 * @module domHelper
 */

import $ from 'qwery';


/**
 * Remove an element from the DOM.
 *
 * @param {Node} element
 */
export function removeElement (element) {
    element && element.parentNode && element.parentNode.removeChild(element);
}

/**
 * Move an element after another element.
 *
 * @param {Node} element
 * @param {Node} afterElement
 */
export function moveAfterElement (element, afterElement) {
    if ((element && element.parentNode) && (afterElement && afterElement.parentNode)) {
        removeElement(element);
        afterElement.parentNode.insertBefore(element, afterElement.nextSibling);
    }
}

/**
 * Get the last element from element list.
 *
 * @param {string} selector
 * @param {string|Node} context
 * @returns {Node}
 */
export function getLastElement (selector, context) {
    const elements = $(selector, context);
    return elements.pop();
}

/**
 * Checks whether an element is visible in the viewport.
 *
 * @param {Node} element
 */
export function isInViewport (element) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();

    return (
        rect.bottom >= 0
        && rect.right >= 0

        && rect.top <= (
            window.innerHeight
            || document.documentElement.clientHeight)

        && rect.left <= (
            window.innerWidth
            || document.documentElement.clientWidth)
    );
}

/**
 * Get the first control input element with matching value.
 *
 * @param {string} selector
 * @param {string|Node} context
 * @returns {Node}
 */
export const getInputByValue = (value, context) => $(`input[value="${value}"]`, context)[0];
